import { render, staticRenderFns } from "./orderStatementItemsSummaryBox.vue?vue&type=template&id=39b818ae&"
import script from "./orderStatementItemsSummaryBox.vue?vue&type=script&lang=ts&"
export * from "./orderStatementItemsSummaryBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports